<template>
  <v-layout class="svg-icon">
    <svg
      :viewBox="viewBox"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      :width="width"
      :height="height"
    >
      <use :xlink:href="href" />
    </svg>
  </v-layout>
</template>
<script>
  const icons = require("@/assets/images/icons.svg");

  export default {
    name: "SvgIcon",
    props: {
        icon: String,
        size: String || Number,
        viewBox: {
            type: String,
            default: " 0 0 360 360"
        }
    },
    computed: {
      href() {
        var url = icons + "#" + this.icon,
            relativUrl = url.split("public")[1];
        if (relativUrl) {
            return "/vue/public" + relativUrl;
        }
        return url;
      },
      width() {
          var width = 360;
          if (this.size) {
              width = this.size.split(/\*|,/)[0];
          }
          return width;
      },
      height() {
          var height = 350;
          if (this.size) {
              height = this.size.split(/\*|,/)[1];
              if (!height) {
                  height = this.size.split(/\*|,/)[0];
              }
          }
          return height;
      }
    }
  };
</script>










